import fetch from 'isomorphic-fetch'

export const USER_CHECK_REQUEST= 'USER_CHECK_REQUEST'
export const USER_CHECK_SUCCESS= 'USER_CHECK_SUCCESS'
export const USER_CHECK_FAILURE= 'USER_CHECK_FAILURE'

export const SET_USER_SESSION = 'SET_USER_SESSION'

export const USER_ACCEPT_TERMS_REQUEST= 'USER_ACCEPT_TERMS_REQUEST'
export const USER_ACCEPT_TERMS_SUCCESS= 'USER_ACCEPT_TERMS_SUCCESS'
export const USER_ACCEPT_TERMS_FAILURE= 'USER_ACCEPT_TERMS_FAILURE'
export const USER_HAS_ACCEPTED_TERMS = 'USER_HAS_ACCEPTED_TERMS'
export const SHOW_TERMS_PAGE = 'SHOW_TERMS_PAGE'
export const UPDATE_ACCESS_FORM_MESSAGE = 'UPDATE_ACCESS_FORM_MESSAGE'
export const UPDATE_JWT_TOKEN = 'UPDATE_JWT_TOKEN'
export const TOGGLE_USER_REGISTERED_STATUS = 'TOGGLE_USER_REGISTERED_STATUS'

export const UPDATE_SMART_ADDRESS = 'UPDATE_SMART_ADDRESS'
export const SMART_ADDRESS_REQUEST = 'SMART_ADDRESS_REQUEST'
export const SMART_ADDRESS_FAILURE = 'SMART_ADDRESS_FAILURE'
export const SHOW_PAY_ADDRESS = 'SHOW_PAY_ADDRESS'
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'

const Config = {
  POST: {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },

  },
  GET: {
    mode: 'cors',
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
  }
}

function fetchUserRequest(email, hex) {
  return {
    type: USER_CHECK_REQUEST,
    email,
    hex
  }
}

function fetchUserSuccess(response, message) {
  return {
    type: USER_CHECK_SUCCESS,
    response,
    message
  }
}

function fetchUserFailure(response) {
  return {
    type: USER_CHECK_FAILURE,
    message: "Error in the server"
  }
}

function updateMessage(message) {
  return {
    type: UPDATE_ACCESS_FORM_MESSAGE,
    message
  }
}

function updateToken(token) {
  return {
    type: UPDATE_JWT_TOKEN,
    token
  }
}

function toggleRegistrationStatus(status) {
  return {
    type: TOGGLE_USER_REGISTERED_STATUS
  }
}

const validateEmail = (email) => {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const fetchUser = (email, hex) => dispatch => {
  if ( !email || !hex ) {
    dispatch(updateMessage('Both email and ethereum address fields are mandatory'))
    return
  }
  if (hex.length !== 42) {
    dispatch(updateMessage('Please enter the right Ethereum address. (Make sure you put 0x in the beginning.)'))
    return
  }
  if(!validateEmail(email)) {
    dispatch(updateMessage('Please enter the email address in the correct format correct (john@doe.com)'))
    return
  }
  dispatch(fetchUserRequest(email, hex))
  Config.POST.body = JSON.stringify({ email: email, hex: hex })
  return fetch('/api/register', Config.POST)
    .then(response => response.json().then(user => ({ user, response })))
    .then(({ user, response }) =>  {
      if(!response.ok) {
        dispatch(fetchUserFailure(response))
      } else {
        if(user.status && user.status === 101) {
          dispatch(fetchUserFailure(response))
          dispatch(updateMessage("We seem to have an issue with the ETH address " +
            "that you have provided, please contact dipesh@indorse.io to solve this issue."))
          return
        }
        user.email = email
        user.hex = hex
        // Some crazy error case
        if(!user.userFound && user.error) {
          dispatch(fetchUserFailure(user))
        }
        // Using for the first time so user is not found and is registered
        if(!user.userFound && user.userRegistered && !user.address) {
          window.sessionStorage.setItem("token","")
          let message = 'Sorry, your email address is not registered in our database. ' +
            'We request you to get in touch with us through dipesh@indorse.io'
          dispatch(updateMessage(message))
          dispatch(toggleRegistrationStatus())
        }
        // Trying to log in before whitelisting
        if(user.userFound && !user.whitelist && !user.address) {
          window.sessionStorage.setItem("token","")
          let message = 'Sorry, your email address is not registered in our database. ' +
            'We request you to get in touch with us through dipesh@indorse.io'
          dispatch(updateMessage(message));
        }
        // Trying to log in after whitelisting
        if(user.userFound && user.whitelist && user.token && !user.terms && !user.address) {
          window.sessionStorage.setItem("token", user.token);
          dispatch(updateToken(user.token))
          dispatch(showTerms(user))
        }
        // Logging in after accepting terms
        if(user.userFound && user.whitelist && user.terms && user.token && !user.address) {
          dispatch(termsAccepted())
          dispatch(updateToken(user.token))
          dispatch(fetchSmartAddress(user))
        }
        // To the smart address page
        if(user.userFound && user.whitelist && user.address) {
          dispatch(updateSmartAddress(user.address))
          return
        }
      }
    }).catch(ex => dispatch(fetchUserFailure(ex)))
}

const setSession = () => ({
  type: SET_USER_SESSION
})

export const loadSession = () => dispatch => {
  dispatch(setSession())
}

const acceptTermsRequest = () => ({
  type: USER_ACCEPT_TERMS_REQUEST
})

const acceptTermsSuccess = (response) => ({
  type: USER_ACCEPT_TERMS_SUCCESS,
  response
})

const acceptTermsFailure= (response, message) => ({
  type: USER_ACCEPT_TERMS_FAILURE,
  response,
  message
})

const termsAccepted = () => ({
  type: USER_HAS_ACCEPTED_TERMS
})

const showTerms = (user) => ({
  type: SHOW_TERMS_PAGE,
  token: user.token,
  whitelist: user.whitelist
})

export const acceptTerms = (email, hex) => dispatch => {
  dispatch(acceptTermsRequest())
  let token = window.sessionStorage.getItem("token")
  Config.POST.body = JSON.stringify({ email: email, token: token, terms: "true", hex: hex })
  return fetch('/api/register', Config.POST)
    .then(response => response.json().then(user => ({ user, response })))
    .then(({ user, response }) =>  {
      user.email = email
      if(!response.ok) {
        dispatch(acceptTermsFailure(response));
      } else {
        user.email = email
        if(user.error) {
          dispatch(acceptTermsFailure(user, user.error))
        }
        if(user.userFound && user.whitelist && user.address) {
          dispatch(acceptTermsSuccess())
          dispatch(updateSmartAddress(user.address))
          dispatch(showAddress())
          return
        }
      }
    }).catch(ex => dispatch(acceptTermsFailure(ex)))
}



function updateSmartAddress(address) {
  return {
    type: UPDATE_SMART_ADDRESS,
    address
  }
}

function smartAddressRequest(data) {
  return {
    type: SMART_ADDRESS_REQUEST,
    data
  }
}

function smartAddressFailure(response) {
  return {
    type: SMART_ADDRESS_FAILURE,
    message: "Error in the server",
    response
  }
}

const fetchSmartAddress = data => dispatch => {
  dispatch(smartAddressRequest(data))
  Config.POST.body = JSON.stringify({ email: data.email, token: data.token, hex: data.hex })
  return fetch('/api/register', Config.POST)
    .then(response => response.json().then(user => ({ user, response })))
    .then(({ user, response }) =>  {
      console.log(user)
      if(!response.ok) {
        dispatch(smartAddressFailure(response))
      } else {
        user.email = data.email
        user.token = data.token
        if(user.address) {
          dispatch(updateSmartAddress(user.address))
          dispatch(showAddress())
        }
      }
    }).catch(ex => dispatch(fetchUserFailure(ex)))
}

export const showAddress = ( ) => ({
  type: SHOW_PAY_ADDRESS
})

export const setPaymentMethod = ( payment ) => ({
  type: SET_PAYMENT_METHOD,
  payment
})



// WEBPACK FOOTER //
// ./src/actions/index.js